export { default } from './CollectionFiltered';
export type { Settings } from './CollectionFiltered';
